export default "__VITE_ASSET__CqrmufxA__"